module.exports = __webpack_public_path__ + "img/假期管理.c3675f69.svg";